export default __webpack_public_path__ + "static/media/wineflight.4154e8e5.jpeg";